/*
 * Special Module for handling the Contents and Content pages, and switching between them without distroying each other
 * This module basically is just a wrapper for the Contents and Content modules, but handles some functionality for
 * switching between them
 */

define([
  "marionette",
  "backbone",
  "jquery",
  "configuration/properties",
  "messaging/messenger",
  "modules/contentsSplit/contentsSplitView",
  "modules/contentsSplit/contents/contentsModule",
  "modules/contentsSplit/content/contentModule",
], function (
  Marionette,
  Backbone,
  $,
  Properties,
  Messenger,
  ContentsSplitView,
  ContentsModule,
  ContentModule,
) {
  const ContentsSplitController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "contentsSplit";
      this.region = options.region;
      this._setUpVents();
      this.router = new Router({
        controller: this,
      });
    },
    show: function () {
      this.contentsLoaded = false; //true if we have shown the contents page before
      this.selectedSearchLocale = Messenger.reqres.request("default:response:language");
      this.layout = new ContentsSplitView.contentsSplitLayout();
      this.contents = this.addSubModule(new ContentsModule({ region: this.layout.contentsRegion }));
      this.content = this.addSubModule(new ContentModule({ region: this.layout.contentRegion }));
      this.showRegion(this.layout);
    },
    showContent: function (content, mappingId) {
      Messenger.command.execute("change:menu", "contents");
      //set URL
      const kbId = Messenger.reqres.request("active:kb");
      if (content.isNew()) {
        //simply use the content url because the content does not have an id
        Backbone.history.navigate(kbId + "/contents/new");
      } else {
        Backbone.history.navigate(kbId + "/content/" + mappingId); //use the separate mappingId to fill out URL
      }

      if (!this.isOpen) {
        //initialize region if we haven't done so already
        this.show();
      }

      Messenger.onSave(function () {
        this.content.save();
      }, this);

      //hide contents page
      this.layout.hideContents();
      //unhide content page
      this.layout.showContent();

      //make sure main region is visible
      this.region.trigger("show");

      //toggle isOpen parameter
      this.contents.isOpen = false;
      //show content page (always get a fresh page)
      this.content.show(content, this.selectedSearchLocale);
    },
    showContents: function () {
      Messenger.command.execute("change:menu", "contents");
      //set URL
      const kbId = Messenger.reqres.request("active:kb");
      //if the hash has "/new" at the end, then replace the existing history entry
      const endsWithNew = window.location.hash.slice(-4) === "/new";
      Backbone.history.navigate(kbId + "/contents", { replace: endsWithNew });
      document.title = $.t("menuBar.content") + " - " + Properties.applicationName;
      if (!this.isOpen) {
        this.show();
      }

      Messenger.onSave(function () {
        this.contents.save();
      }, this);

      //hide content page
      this.layout.hideContent();
      //unhide contents page
      this.layout.showContents();

      //make sure main region is visible
      this.region.trigger("show");
      this.content.isOpen = false;
      if (!this.contentsLoaded) {
        //contents page hasn't been shown before, so create it and show it
        this.contents.show();
        this.contentsLoaded = true;
      } else {
        this.contents.isOpen = true; //toggle isOpen parameter
      }
      //otherwise, we get the existing version of contents we had hidden
    },
    _routeContent: function (kbId, contentId) {
      const isAuthor = Messenger.reqres.request("user:is:author", kbId);
      if (!isAuthor) {
        Backbone.history.navigate("", { trigger: true });
        return;
      }
      //set active kb
      Messenger.command.execute("set:active:kb", kbId);
      Messenger.command.execute("change:menu", "contents"); //use same menu icon as contents
      const content = Messenger.reqres.request("content", contentId); //load content from server
      this.showContent(content, contentId);
    },
    _routeContents: function (kbId) {
      const isAuthor = Messenger.reqres.request("user:is:author", kbId);
      if (!isAuthor) {
        //redirect to home
        Backbone.history.navigate("", { trigger: true });
        return;
      }
      //set active kb
      Messenger.command.execute("set:active:kb", kbId);
      Messenger.command.execute("change:menu", "contents");
      this.showContents();
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "show:contents",
        function () {
          this.showContents();
        },
        this,
      );

      Messenger.vent.on(
        "show:content",
        function (content) {
          this.showContent(content, content.get("mappingId"));
        },
        this,
      );

      Messenger.vent.on(
        "set:content:search:locale",
        function (localeId) {
          this.selectedSearchLocale = localeId;
        },
        this,
      );
    },
  });

  const Router = Marionette.AppRouter.extend({
    appRoutes: {
      ":kbId/contents(/new)": "_routeContents",
      ":kbId/content/:mappingId": "_routeContent",
    },
  });

  return ContentsSplitController;
});
